import * as React from 'react'
import {Link} from "gatsby";

const Overlay = () => {
    return (
        <div className="ort">
            <div className="information">
                <div className="image" id="image">
                    <img alt="" className="ort-img dummy" src={"/images/Logo_ODD.svg"}/>                
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            Ismaning     
                        </h2>
                    </div>
                </div>
                <p>
Ziviler Widerstand der Freiheitsaktion Bayern am 28. April 1945 mit Besetzung des Rundfunksenders und Aufruf zur Beendigung der NS-Diktatur.
</p>
            </div>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                Mehr erfahren
            </Link>

        </div>
    )
}

export default Overlay

